import React, { useContext, useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Button,
  Divider,
  Grid,
  Collapse,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../../Context/Langcontext";
import useReactRouter from "use-react-router";
import DataServiceList from "../../../Component/List/dataservice";
import { FaCircle } from "react-icons/fa";
import MapServiceList from "../../../Component/List/mapservice";
import {
  IoIosArrowDropdownCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";

const useStyle = makeStyles((theme) => ({
  root: { height: "100%", width: "100%", backgroundColor: "#FFFFFF" },
  cardStyle: {
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    width: "85%",
    marginTop: "2.5rem",
    marginBottom: "2.5rem",
  },
  maintext: {
    fontSize: "1.2rem",
    fontWeight: 700,
    textAlign: "center",
    color: "#595A5A",
  },
  divider: {
    margin: "2rem",
    height: 3,
  },
  itemsecond: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  secondtext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    maxWidth: 860,
  },
  btndocument: {
    fontSize: "1rem",
    fontWeight: 400,
    color: "#E16733",
    textTransform: "unset",
    marginTop: "1rem",
    borderRadius: 25,
  },
  detailtext: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595A5A",
    paddingBottom: "0.5rem",
    marginTop: "0.5rem",
    display: "flex",
    alignItems: "center",
  },
  nametext: {
    fontSize: "1.2rem",
    fontWeight: 700,
    color: "#E16733",
  },
  itemcenter: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  paperStyle: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    padding: "1rem 0rem",
    cursor: "pointer",
  },
}));

const Detailservice = ({ type, setType }) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history, location } = useReactRouter();

  useEffect(() => {
    if (location.hash === "#data") {
      setType(0);
    } else if (location.hash === "#map") {
      setType(1);
    }
  }, [location, setType]);

  const [service, setService] = useState([
    {
      title: lang.DataService,
      data: [
        {
          name: lang.LandBaseDataAPI,
          detail: DataServiceList().landbase,
          path: "mea_data_service",
          expand: false,
        },
        {
          name: lang.ElectricDataAPI,
          detail: DataServiceList().electric,
          path: "mea_data_service",
          expand: false,
        },
      ],
    },
    {
      title: lang.MapService,
      data: [
        {
          name: lang.Vector,
          detail: MapServiceList().vector,
          path: "mea_map_service",
          expand: false,
        },
        {
          name: lang.Raster,
          detail: MapServiceList().raster,
          path: "mea_map_service",
          expand: false,
        },
      ],
    },
  ]);

  const expandService = (ind, index) => {
    let exservice = [...service];
    exservice[ind].data[index].expand = !exservice[ind].data[index].expand;
    setService(exservice);
  };

  return (
    <div
      style={{
        textAlign: "center",
      }}
    >
      <Divider className={classes.divider} />
      <Typography
        className={classes.maintext}
        data-aos="fade-up"
        data-aos-anchor-placement="top-center"
        data-aos-duration="1500"
      >
        {type === 0 ? service[0].title : service[1].title}
        {/* have API providing
        services include */}
      </Typography>

      <div
        className={classes.itemsecond}
        data-aos="fade-up"
        data-aos-anchor-placement="top-center"
        data-aos-duration="1500"
      >
        {/* <Typography className={classes.secondtext}>
          Usu habeo equidem sanctus no. Suas summo id sed, erat erant oporteat
          cu pri. In eum omnes molestie. Sed ad debet scaevola, ne mel.
        </Typography> */}
      </div>

      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
        }}
      >
        <Grid container spacing={0}>
          {type === 0
            ? service[0].data.map((item, i) => {
                return (
                  <Grid item md={6} sm={12} key={item.name}>
                    <div className={classes.itemcenter}>
                      <Card className={classes.cardStyle}>
                        <CardContent
                          style={{ textAlign: "left", padding: "2rem" }}
                        >
                          <Paper
                            className={classes.paperStyle}
                            onClick={() => {
                              expandService(0, i);
                            }}
                          >
                            <Grid
                              container
                              spacing={0}
                              style={{ justifyContent: "center" }}
                            >
                              <Grid item xs={10}>
                                <Typography
                                  className={classes.nametext}
                                  style={{ marginLeft: "1rem" }}
                                >
                                  {item.name}
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                xs={2}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                }}
                              >
                                {item.expand ? (
                                  <IoIosArrowDropdownCircle
                                    size={24}
                                    color="#E16733"
                                    style={{ marginRight: "1rem" }}
                                  />
                                ) : (
                                  <IoIosArrowDroprightCircle
                                    size={24}
                                    color="#E16733"
                                    style={{ marginRight: "1rem" }}
                                  />
                                )}
                              </Grid>
                            </Grid>
                          </Paper>

                          <Collapse
                            in={item.expand}
                            timeout="auto"
                            unmountOnExit
                            style={{ paddingTop: "0.5rem" }}
                          >
                            {item.detail.map((rs, id) => {
                              return (
                                <Typography
                                  key={`${rs.title}_${id}`}
                                  className={classes.detailtext}
                                >
                                  <FaCircle
                                    size={10}
                                    style={{ margin: "0rem 0.5rem" }}
                                  />
                                  {rs.title}
                                </Typography>
                              );
                            })}
                          </Collapse>

                          <Divider style={{ marginTop: "1rem" }} />
                          <Button
                            className={classes.btndocument}
                            onClick={() => {
                              history.push(`/home/document/#${item.path}`);

                              setTimeout(() => {
                                let element = document.getElementById(
                                  item.path
                                );
                                let offTop = element.offsetTop;
                                window.scrollTo({
                                  top: offTop - 100,
                                  left: 0,
                                  behavior: "smooth",
                                });
                              }, 1000);
                            }}
                          >
                            {`${lang.DOCUMENT} >>`}
                          </Button>
                        </CardContent>
                      </Card>
                    </div>
                  </Grid>
                );
              })
            : service[1].data.map((item, i) => {
                return (
                  <Grid item md={6} sm={12} key={item.name}>
                    <div className={classes.itemcenter}>
                      <Card className={classes.cardStyle}>
                        <CardContent
                          style={{ textAlign: "left", padding: "2rem" }}
                        >
                          <Paper
                            className={classes.paperStyle}
                            onClick={() => {
                              expandService(1, i);
                            }}
                          >
                            <Grid
                              container
                              spacing={0}
                              style={{ justifyContent: "center" }}
                            >
                              <Grid item xs={10}>
                                <Typography
                                  className={classes.nametext}
                                  style={{ marginLeft: "1rem" }}
                                >
                                  {item.name}
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                xs={2}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                }}
                              >
                                {item.expand ? (
                                  <IoIosArrowDropdownCircle
                                    size={24}
                                    color="#E16733"
                                    style={{ marginRight: "1rem" }}
                                  />
                                ) : (
                                  <IoIosArrowDroprightCircle
                                    size={24}
                                    color="#E16733"
                                    style={{ marginRight: "1rem" }}
                                  />
                                )}
                              </Grid>
                            </Grid>
                          </Paper>
                          <Collapse
                            in={item.expand}
                            timeout="auto"
                            unmountOnExit
                            style={{ paddingTop: "0.5rem" }}
                          >
                            {item.detail.length ? (
                              item.detail.map((rs, id) => {
                                return (
                                  <Typography
                                    key={`${rs.title}_${id}`}
                                    className={classes.detailtext}
                                  >
                                    <FaCircle
                                      size={10}
                                      style={{ margin: "0rem 0.5rem" }}
                                    />
                                    {rs.title}
                                  </Typography>
                                );
                              })
                            ) : (
                              <Typography className={classes.detailtext}>
                                {lang.NoService}
                              </Typography>
                            )}
                          </Collapse>

                          <Divider style={{ marginTop: "1rem" }} />
                          <Button
                            className={classes.btndocument}
                            onClick={() => {
                              history.push(`/home/document/#${item.path}`);

                              setTimeout(() => {
                                let element = document.getElementById(
                                  item.path
                                );
                                let offTop = element.offsetTop;
                                window.scrollTo({
                                  top: offTop - 100,
                                  left: 0,
                                  behavior: "smooth",
                                });
                              }, 1000);
                            }}
                          >
                            {`${lang.DOCUMENT} >>`}
                          </Button>
                        </CardContent>
                      </Card>
                    </div>
                  </Grid>
                );
              })}
        </Grid>
      </div>
    </div>
  );
};

export default Detailservice;
